import { FC, useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/buttons/Button';
import { ModalsContext, ModalType } from 'contexts/modal';
import { useFranceLocale } from 'hooks/franceLocale';

import { ScAuthButtons, ScAuthButtonsProps } from './styled';
import { ScButtonProps } from 'components/buttons/Button/styled';

interface AuthButtonsProps
  extends ScAuthButtonsProps,
    Pick<ScButtonProps, 'large' | 'xLarge'> {
  onLoginClick?: () => void;
  onJoinNowClick?: () => void;
}

export const AuthButtons: FC<AuthButtonsProps> = ({
  large = true,
  xLarge,
  onJoinNowClick,
  onLoginClick,
  ...props
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('glossary');

  const { isFRWithoutStag } = useFranceLocale();

  const { handleModal } = useContext(ModalsContext);

  const btnSize = useMemo(() => {
    if (xLarge) return { xLarge: true };
    if (large) return { large: true };
  }, [large, xLarge]);

  const handleLoginClick = useCallback(() => {
    handleModal(ModalType.Login)();
    onLoginClick && onLoginClick();
  }, [handleModal, onLoginClick]);

  const handleJoinNowClick = useCallback(() => {
    handleModal(ModalType.Registration)();
    onJoinNowClick && onJoinNowClick();
  }, [handleModal, onJoinNowClick]);

  return (
    <ScAuthButtons className={language} {...props} hideRegBtn={isFRWithoutStag}>
      <Button greenTransparent onClick={handleLoginClick} {...btnSize}>
        {t('login')}
      </Button>
      {!isFRWithoutStag && (
        <Button animated green onClick={handleJoinNowClick} {...btnSize}>
          {t('joinNow')}
        </Button>
      )}
    </ScAuthButtons>
  );
};
